import { TableCell, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import type { ResourceType } from "../../../../admin/organization/resources/resourcesTypes"

import { HomePrintSection, visibleOnlyWhenPrinting } from "../homePrintMode"
import { PrintTable } from "../PrintTable"
import type { BookingDisplayRow } from "./helpers"

const useStyles = makeStyles()(() => ({
    root: visibleOnlyWhenPrinting(HomePrintSection.BOOKINGS),
}))

type Props = Readonly<{
    rows: ReadonlyArray<BookingDisplayRow>
    tab: string
    date: string
    resourceType: ResourceType
}>

export function PrintBookingsList({ rows, tab, date, resourceType }: Props) {
    const { classes } = useStyles()

    return (
        <PrintTable
            className={classes.root}
            title={
                <LocalizedStrict id="service-center-reports-dashboard-bookings-print-title" vars={{ tab, date }}>
                    <Typography variant="h6">
                        Bookings – {tab} · {date}
                    </Typography>
                </LocalizedStrict>
            }
            headerCells={
                <>
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-csv-start-header">
                        <TableCell>Start</TableCell>
                    </LocalizedStrict>
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-csv-end-header">
                        <TableCell>End</TableCell>
                    </LocalizedStrict>
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-csv-title-header">
                        <TableCell>Title</TableCell>
                    </LocalizedStrict>
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-csv-type-header">
                        <TableCell>Type</TableCell>
                    </LocalizedStrict>
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-csv-host-header">
                        <TableCell>Host</TableCell>
                    </LocalizedStrict>
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-csv-company-header">
                        <TableCell>Company</TableCell>
                    </LocalizedStrict>
                    <LocalizedStrict id="service-center-reports-dashboard-meetings-csv-location-header">
                        <TableCell>Room</TableCell>
                    </LocalizedStrict>
                </>
            }
            rows={rows.map((row) => ({
                key: row.key,
                cells: [row.start, row.end, row.title, row.type, row.host, row.company, row.room],
            }))}
            empty={
                <LocalizedEnum base="service-center-reports-dashboard-bookings-empty" enumValue={resourceType}>
                    <Typography variant="body1">No bookings on this day</Typography>
                </LocalizedEnum>
            }
        />
    )
}
